import { render, staticRenderFns } from "./CadatroUsuarioCliente.vue?vue&type=template&id=a18d7bee&scoped=true"
import script from "./CadatroUsuarioCliente.vue?vue&type=script&lang=js"
export * from "./CadatroUsuarioCliente.vue?vue&type=script&lang=js"
import style0 from "./CadatroUsuarioCliente.vue?vue&type=style&index=0&id=a18d7bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18d7bee",
  null
  
)

export default component.exports